export default {

  recoveryData: {

  },
  errorLogin: '',

}
